import $ from 'jquery'

const modal_polyfill = function (parent = '.modal') {
  console.log('running modal polyfill');
  // Runs after modal is opened, fixes any issues that need polyfilling inside modal
  $(parent).find('button.close').each(function () {
    $(this).addClass('btn-close').empty();
  });
  $(parent).find('label.left-result:not(.form-label').each(function () {
    $(this).addClass('form-label').removeClass('left-result');
  });
  $(parent).find('.clearfix').each(function () { 
    $(this).remove();
  });
  $('[data-dismiss="modal"]').each(function () {
    $(this).attr('data-bs-dismiss', 'modal');
    $(this).removeAttr('data-dismiss');
  });
  if ($(parent).find('.modal-dialog').parents('form').length > 0) {
    console.log('Found forms outside modal-dialog, moving them inside...');
    // Move form inside .modal-dialog
    $(parent).find('.modal-dialog').each(function () {
      const $form = $(this).parents('form');
      if ($form.length > 0) {
        const $modalDialogContent = $(this).contents();
        const $modalDialogEmpty = $(this).empty();
        const $formEmpty = $(this).parents('form').empty();  
        $form.remove();
        $(parent).append($modalDialogEmpty.append($formEmpty.html($modalDialogContent)));
      }
    });
  }
  run_polyfills(true);
  popover_polyfill();
  tooltip_polyfill();
  if (typeof reInitialiseAllSelect2 === 'function') {
    reInitialiseAllSelect2();
  }
}
window.modal_polyfill = modal_polyfill;
const tab_polyfill = (target = '.ui.pointing.menu, .ui.tabular.menu') => {
  function execute_polyfill(type='normal', $target){
    // Adds correct styling classes + structure to Tabs
    if (!$target.hasClass('nav') && !$target.hasClass('nav-tabs')){
      window.bt_logger({
        'file': 'user/themes/bootstrap5/src/js/polyfills.js',
        'line': '42',
        'description': 'The tabs on this page are not supported by Bootstrap5, so a polyfill has been engaged. Please update the tabs to support the new Bootstrap5 structure.',
        'type': 'polyfill',
        'severity': 'warning',
      });
  
      $target.addClass(`nav ${type == 'normal' ? 'nav-tabs' : 'nav-pills'}`).attr('role', 'tablist');
      var $tabPanes = [];
      $target.find('.item[data-tab]').each( function () {
        var $tabLi = $(this);
        var $tabLink = $(this).html();
        $(this).addClass('nav-item');
        if ($tabLi.get(0).tagName == 'A') {
          // Fixes if the anchor is not an <li> element
          $(this).replaceWith(`<li class="nav-item" role="presentation"><a class="nav-link ${$tabLi.hasClass('active') ? 'active' : ''}" data-bs-toggle="tab" data-bs-target="#${$tabLi.attr('data-tab')}">${$tabLink}</a></li>`);
        } else {
          $(this).html(`<a class="nav-link ${$tabLi.hasClass('active') ? 'active' : ''}" data-bs-toggle="tab" data-bs-target="#${$tabLi.attr('data-tab')}"> ${$tabLink}</a>`);
        }
        $(this).on('change', function () {
          // Handle tab change
          if ($(this).find('.nav-link').hasClass('active')) {
            $(this).find('.nav-link').addClass('active');
          } else {
            $(this).find('.nav-link').removeClass('active');
          }
        });
        if (type !== 'ajax'){ 
          $tabPanes.push($(`[data-tab="${$tabLi.attr('data-tab')}"]`));
          $(`[data-tab="${$tabLi.attr('data-tab')}"]`).remove(); // Remove tab pane from the DOM
    
        }
      });
      setTimeout( () => $target.find('.nav-item.active a.nav-link').addClass('active'), 100); // Fix active item after DOM updated
      if (type !== 'ajax'){ 
        // Wraps the tabs in tab-content div
        var $tabContent = $(`<div class="tab-content"></div>`);
        $.each($tabPanes, function () {
          $tabContent.append($(this).attr('id', $(this).attr('data-tab')).attr('role', 'tabpanel').addClass('tab-pane'));
        });
        $target.after($tabContent);
      }
  
    }
  }
  $('#ajaxTabs').each( function(){ 
    // Adds correct styling classes + structure to ajax Tabs
    execute_polyfill('ajax', $(this))
  })
  $('.ui.pointing.menu, .ui.tabular.menu').each( function () {
    execute_polyfill('normal', $(this))
  });

  $('.nav.nav-tabs').each( function () {
    // Update old bootstrap tabs
    $(this).find('.nav-item:not([role="presentation"]').each( function () {
      $(this).attr('role', 'presentation');
    });

    $(this).find('.nav-item .nav-link[href]:not([data-bs-target])').each( function () {
      $(this).attr('data-bs-toggle', 'tab').attr('data-bs-target', $(this).attr('href'));
    });
  });
}
const input_polyfill = () => {
  // Add .form-check-input class to checkboxes
  $('input[type="checkbox"]:not(.form-check-input)').each(function () {
    $(this).addClass('form-check-input');
    if ($(this).hasClass('toggle')){
      $(this).wrap('<div class="form-check form-switch"></div>');
    } else {
      $(this).addClass('form-check-input');
    }
    $(this).next('label.checkbox:not(.form-check-label)').each(function () {
      $(this).addClass('form-check-label');
    });
  });
  $('.form-check').each(function () {
    if ($(this).find('.form-check-label').length == 0 && $(this).find('.form-check-input').length){
      var input = $(this).find('.form-check-input');
      var text = $(this).text();
      if (text && text.length > 0){
        $(this).html(`<label class="form-check-label">${text}</label>`);
        $(this).prepend(input);  
      }
    }
  });

  // Add .form-check-input class to radios
  $('input[type="radio"]:not(.form-check-input)').each(function () {
    $(this).addClass('form-check-input');
    $(this).wrap('<div class="form-check"></div>');
  });
  
  $('.selection-toggle-label').each( function () {
    $(this).find('.selection_checkbox').addClass('form-check-input');
  });
  $('.toggle-button').each( function () {
    $(this).addClass('form-check-label');
  });
  $('.input-group .input-group-addon:first-child').each(function () {
    if (!($(this).find('.input-group-text').length > 0)){
      $(this).addClass('input-group-text').removeClass('input-group-addon');
    }
  });
}
const selectionToggleLabelPolyfill = ($el) => {
  // Add this function to click events on .selection-toggle-label elements to fix toggling issues
  var $checkbox = $el.find('.selection_checkbox');
  $el.toggleClass('active');
  $el.closest('tr').toggleClass('ticket-highlight');
  $checkbox.prop('checked', !$checkbox.prop('checked'));
}
window.selectionToggleLabelPolyfill = selectionToggleLabelPolyfill;
const button_polyfill = () => {
  $('.btn-success-outline').each( function () {
    $(this).addClass('btn-outline-success');
  });
  $('.btn-warning-outline').each( function () {
    $(this).addClass('btn-outline-warning');
  });
  $('.btn-danger-outline').each( function () {
    $(this).addClass('btn-outline-danger');
  });
  $('.btn-info-outline').each( function () {
    $(this).addClass('btn-outline-info');
  });
}
const card_polyfill = () => {
  $('.panel').each(function () {
    $(this).addClass('card');
    $(this).find('.panel-heading').addClass('card-header');
    $(this).find('.panel-body').addClass('card-body');
  });
  $('.panel, .card').each(function () {
    $(this).find('h1.panel-title').each( function () {
      const content = $(this).html();
      $(this).replaceWith(`<h4>${content}</h4>`);
    });
  });
}
const breadcrumb_polyfill = () => {
  $('.breadcrumb').each(function () {
    var isCorrect = $(this).parent('nav[aria-label="breadcrumb"]').length > 0 ? true : false;
    if (!isCorrect) {
      $(this).wrap('<nav aria-label="breadcrumb"></nav>');
    }
    $(this).find('li:not(.breadcrumb-item)').each(function () {
      $(this).addClass('breadcrumb-item');
    });
  });
}
const tooltip_polyfill = () => {
  $('[data-toggle="tooltip"]').each(function () {
    $(this).attr('data-bs-toggle', 'tooltip');
    $(this).removeAttr('data-toggle').removeAttr('aria-controls');
    $(this).attr('data-bs-placement', $(this).attr('data-placement'));
    $(this).attr('data-bs-html', 'true');
    $(this).attr('title', $(this).attr('data-original-title'));
    var tooltip = new bootstrap.Tooltip($(this));
  });
}
const popover_polyfill = () => {
  $('[data-toggle="popover"], .popover-item').each(function () {
    console.log('popover', $(this));
    $(this).attr('data-bs-toggle', 'popover');
    $(this).attr('data-bs-content', $(this).attr('data-content'));
    $(this).attr('title', $(this).attr('data-title'));
    return new bootstrap.Popover(this, {
      container: '#content-wrapper',
      html: true,
      trigger: "hover focus",
      delay: 125,
    })
  });
}
const button_group_polyfill = () => {
  // Fixes old style button group that require toggling
  $('.btn-group').each(function () {
    if ($(this).find('.selection_checkbox').length > 0 && $(this).find('.selection_checkbox').parent().hasClass('btn')) {
      // Is old-style btn-group requiring toggle
      $(this).find('.btn').each(function () {
        $(this).find('input[type="checkbox"]').hide();
        $(this).addClass('selection-toggle-label');
      });
    }
  });
}
const data_toggle_polyfill = () => {
  $('[data-toggle="collapse"]').each(function () {
    $(this).attr('data-bs-toggle', 'collapse');
    $(this).removeAttr('data-toggle').removeAttr('aria-controls');
  });
}
const alert_polyfill = () => {
    // Fixes out of date bootstrap alert markup
  $('.alert .close:first-child').each(function () {
    var $parent = $(this).parent('.alert');
    $(this).remove();
    var $content = $parent.html();
    $parent.html('<div>'+$content+'</div><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span></button>');
  });
}

const run_polyfills = (noModal = false) => {
  data_toggle_polyfill();
  alert_polyfill();
  input_polyfill();
  button_polyfill();
  card_polyfill();
  breadcrumb_polyfill();
  if (!noModal) modal_polyfill();
  tab_polyfill();
  button_group_polyfill();
  // Popovers are already fixed in bootstrap-components.js
  // Tooltips are already fixed in bootstrap-components.js
} 
$(function () {
  run_polyfills();
});
